module.exports = ".ng-valid[required], .ng-valid.required {\n  border-left: 5px solid #42A948;\n  /* green */ }\n\n.ng-invalid:not(form) {\n  border-left: 5px solid #a94442;\n  /* red */ }\n\n.overflow-card {\n  overflow: auto; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/allocation-modal/allocation-modal.component.scss
// module id = ./src/app/allocation-modal/allocation-modal.component.scss
// module chunks = main